import { DependencyList, useEffect } from "react";
import { AsyncThunkAction } from "@reduxjs/toolkit";
import { useAppDispatch } from "../framework/customStore";
import { AnyAction } from "redux";

export const useAsyncThunkAction = (
    action: () => AsyncThunkAction<any, any, any>,
    {
        onSuccess,
        onError,
    }: {
        onSuccess?: (value: void) => void | PromiseLike<void>;
        onError?: (reason: any) => void | PromiseLike<void>;
    },
    deps?: DependencyList,
    condition: boolean = true
) => {
    const dispatch = useAppDispatch();

    useEffect(() => {
        if (condition) {
            const dispatchAction = action();

            if (dispatchAction) {
                // For some reason AppDispatch doesn't include AsyncThunkAction type
                const promise = dispatch(
                    dispatchAction as unknown as AnyAction
                );

                // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                promise
                    .unwrap()
                    .then(onSuccess)
                    .catch((error) => {
                        if (error?.name !== "AbortError") {
                            if (!!onError) {
                                void onError(error);
                            } else {
                                console.error(error);
                            }
                        }
                    });

                return () => {
                    // eslint-disable-next-line @typescript-eslint/no-unsafe-call
                    promise.abort();
                };
            }
        }
    }, deps);
};
